import {TPropsWithChildrenRequire} from 'core/types';
import {IPortalContextProps, PortalContext} from 'modules/portal/context/PortalContext';
import React, {FC} from 'react';

interface IProps extends IPortalContextProps, TPropsWithChildrenRequire {}

export const PortalProvider: FC<IProps> = ({name, onClose, children, visibility}) => {
    return <PortalContext.Provider value={{name, onClose, visibility}}>{children}</PortalContext.Provider>;
};
